// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ca5l","colBig":"styles_colBig__33FYs","colSmall":"styles_colSmall__34hCW"};